var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-date-label"},[_c('div',{staticClass:"chat-date-label__content"},[_vm._v(_vm._s(_vm.formatDateJP2(_vm.date)))])])}
var staticRenderFns = []

export { render, staticRenderFns }